<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="ofertas.content"
      :expanded.sync="expanded"
      class="elevation-1 mt-5"
      :loading="loading"
      :server-items-length="ofertas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma oferta encontrada"
      loading-text="Carregando ofertas..."
      :options="optionsList"
    >
      <template v-slot:item.titulo="{ item }">
        <px-oferta-destaque :oferta="item"/>
        {{ item.titulo }}
      </template>
      <template v-slot:item.precoOriginal="{ item }">
        {{ item.precoOriginal | currency }}
      </template>
      <template v-slot:item.precoAVista="{ item }">
        {{ item.precoAVista | currency }}
      </template>
      <template v-slot:item.precoAPrazo="{ item }">
        {{ item.precoAPrazo | currency }}
      </template>
      <template v-slot:item.situacao="{ item }">
        <px-ativo-custom small :ativo="item.ativo"/>
        <px-ativo-custom small class="mt-1"
                         :ativo="item.disponivel"
                         true-description="Disponível"
                         false-description="Indisponível"/>
      </template>
      <template v-slot:item.options="{ item }">
        <v-btn icon
               @click="goToViewOferta(item)">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
        <px-oferta-edicao-rapida :oferta-param="item" @change="emitChange">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>mdi-currency-usd</v-icon>
            </v-btn>
          </template>
        </px-oferta-edicao-rapida>
        <v-btn icon
               @click="goToEditOferta(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
        <!--        <v-tooltip bottom>-->
        <!--          <template v-slot:activator="{ on }">-->
        <!--            <v-btn icon-->
        <!--                   @click="onClickCopy(item)" v-on="on">-->
        <!--              <v-icon>mdi-content-copy</v-icon>-->
        <!--            </v-btn>-->
        <!--          </template>-->
        <!--          <span>Copiar catálogo</span>-->
        <!--        </v-tooltip>-->
      </template>
    </v-data-table>
    <px-confirm-dialog ref="confirm"/>
  </div>
</template>

<script>
import OfertaEdicaoRapida from './OfertaEdicaoRapida.vue';

export default {
  props: {
    ofertas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      expanded: [],
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Código interno',
          value: 'codigo',
        },
        {
          text: 'Título',
          value: 'titulo',
        },
        {
          text: 'Unidade de medida',
          value: 'unidadeMedida.descricao',
        },
        {
          text: 'Quantidade mínima',
          value: 'quantidade',
        },
        {
          text: 'Preço original',
          value: 'precoOriginal',
        },
        {
          text: 'Preço à vista',
          value: 'precoAVista',
        },
        {
          text: 'Preço a prazo',
          value: 'precoAPrazo',
        },
        {
          text: 'Situação',
          value: 'situacao',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  computed: {},
  methods: {
    emitChange() {
      this.$emit('change');
    },
    updateOptions(options) {
      this.onChangeOptions(options);
    },
    goToEditOferta(item) {
      this.$router.push({
        name: 'main.oferta.edicao',
        params: {
          id: item.id,
        },
      });
    },
    goToViewOferta(item) {
      this.$router.push({
        name: 'main.oferta.detalhes',
        params: {
          id: item.id,
        },
      });
    },
  },
  components: {
    pxOfertaEdicaoRapida: OfertaEdicaoRapida,
  },
};
</script>
